package com.ashes.dev.ai.weather.weathershow

import androidx.compose.foundation.Canvas
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.drawscope.Stroke

@Composable
fun SunIcon(modifier: Modifier = Modifier) {
    Canvas(modifier = modifier) {
        val radius = size.minDimension / 2
        drawCircle(
            color = Color.Yellow,
            radius = radius * 0.7f
        )
        drawCircle(
            color = Color.Yellow,
            radius = radius,
            style = Stroke(width = radius * 0.1f)
        )
    }
}